<template>
  <button @click.stop="$emit('click')">{{text?text:'儲存草稿'}}</button>
</template>

<script>
export default {
  props: ['text']
}
</script>

<style lang="scss" scoped>
@media screen and (orientation: landscape) {
button {
  width: 100px;
  height: 35px;
  color: #FFFFFF;
  border-radius: 20px;
  letter-spacing: 0.1em;
  font-weight: 400;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FFB55F;
}
}
</style>

<style lang="scss" scoped>
@media screen and (orientation: portrait) {
button {
}
}
</style>
